import { z } from 'zod';

const apiConfigSchema = z.object({
  VITE_PUBLIC_API_URL: z.string().min(1),
  VITE_PUBLIC_SOCKET_URL: z.string().min(1),
});

export const apiConfig = apiConfigSchema.parse(import.meta.env);
